import { render, staticRenderFns } from "./reportage.vue?vue&type=template&id=39c29f74&"
import script from "./reportage.vue?vue&type=script&lang=js&"
export * from "./reportage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports